import {AppThunk} from '../index';
import {httpService, HttpWrapperOptions} from '../../../shared/httpWrapper';
import {Act, Agreement} from '../../../shared/models/api';
import {getApiRoute, sleep} from '../../../shared/pipes';
import {apiUrls} from '../../../shared/constants/urls';
import {addNotification} from '../snackbar';
import {SnackbarNotificationType} from '../../../shared/components/snackbar/model';
import {documentsActions} from '../../reducers/documents';
import {Document} from '../../../screens/profile/common/documents/model';
import {Platform} from 'react-native';
import RNFS from 'react-native-fs';
import {storage, StorageKeys} from '../../../shared/storage';
import FileViewer from 'react-native-file-viewer';

export const getDocuments = (): AppThunk => {
  return async (dispatch) => {
    try {
      const agreements = await httpService.get<Agreement[]>(
        getApiRoute(apiUrls.getAgreements),
        new HttpWrapperOptions().Wait(true).ThrowException(true).Errors(true),
      );

      const acts = await httpService.get<Act[]>(
        getApiRoute(apiUrls.getActs),
        new HttpWrapperOptions().Wait(true).ThrowException(false).Errors(false),
      );
      const documents = [
        ...agreements.map((item) => ({...item, type: 'agreement' as const})),
        ...acts.map((item) => ({...item, type: 'act' as const})),
      ];
      if (documents && documents.length !== 0) {
        dispatch(documentsActions.setDocuments(documents));
      }
    } catch (e) {
      dispatch(
        addNotification({
          message: 'Не удалось получить список договоров',
          type: SnackbarNotificationType.Error,
        }),
      );
      dispatch(documentsActions.setDocuments([]));
    } finally {
      dispatch(documentsActions.setDataLoading(false));
    }
  };
};

const handleBase64StingPDF = (responseFromBackEnd: ArrayBuffer, fileName: string) => {
  const arrayBuffer = responseFromBackEnd;
  const blob = new Blob([arrayBuffer], {type: 'application/pdf'});
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${fileName}.pdf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
const apiRouteMap: Record<string, string> = {
  agreement: apiUrls.getAgreementById,
  act: apiUrls.getActById,
};
export const getDocumentFileWeb = ({
  id,
  type,
  fileName,
}: {
  id: number;
  type: Document['type'];
  fileName: string;
}): AppThunk | undefined => {
  if (Platform.OS !== 'web') return;
  return async (dispatch) => {
    try {
      if (!apiRouteMap[type]) {
        throw new Error(`Ошибка типа: ${type}`);
      }
      dispatch(
        addNotification({
          message: `Началась загрузка файла "${fileName}"`,
          type: SnackbarNotificationType.Info,
        }),
      );
      await sleep(200);
      const response = await httpService.get<ArrayBuffer>(
        getApiRoute(apiRouteMap[type], {id: id}),
        new HttpWrapperOptions().Wait(false).ThrowException(false).Errors(false).ResponseType('arraybuffer'),
      );
      handleBase64StingPDF(response, fileName);
      dispatch(
        addNotification({
          message: `Успешно загружен файл: ${fileName}.pdf`,
          type: SnackbarNotificationType.Success,
        }),
      );
    } catch (e) {
      dispatch(
        addNotification({
          message: 'Не удалось загрузить документ, попробуйте позже или обратитесь в тех. поддержку',
          type: SnackbarNotificationType.Error,
        }),
      );
    }
  };
};

export const getDocumentFileMobile = ({
  id,
  type,
  fileName,
}: {
  id: number;
  type: Document['type'];
  fileName: string;
}): AppThunk | undefined => {
  return async (dispatch) => {
    try {
      if (!apiRouteMap[type]) {
        throw new Error(`Ошибка типа: ${type}`);
      }
      const url = getApiRoute(apiRouteMap[type], {id: id});
      const downloadDest = `${RNFS.DocumentDirectoryPath}/${fileName}.pdf`;
      const token = await storage.getItem<string>(StorageKeys.token);
      const options = {
        fromUrl: url,
        toFile: downloadDest,
        headers: {
          Authorization: `Bearer ${token ? token : ''}`,
        },
      };
      dispatch(
        addNotification({
          message: `Началась загрузка файла "${fileName}"`,
          type: SnackbarNotificationType.Info,
        }),
      );
      await sleep(200);

      const result = await RNFS.downloadFile(options).promise;

      if (result.statusCode === 200) {
        dispatch(
          addNotification({
            message: `Успешно загружен файл: ${fileName}.pdf`,
            type: SnackbarNotificationType.Success,
          }),
        );
        FileViewer.open(downloadDest).catch((e) => {
          console.log('[FileViewer opening error]:', e);
          dispatch(
            addNotification({
              message: 'Ошибка открытия документа.',
              type: SnackbarNotificationType.Error,
            }),
          );
        });
      } else {
        throw new Error();
      }
    } catch (error) {
      dispatch(
        addNotification({
          message: 'Не удалось загрузить документ, попробуйте позже или обратитесь в тех. поддержку',
          type: SnackbarNotificationType.Error,
        }),
      );
    }
  };
};
